export enum ContractType {
  MeterContract = "ZVZ",
  OrderContract = "ZVV",
}

export const mapToContractType = (
  contractType: string | undefined,
): ContractType | undefined => {
  if (Object.values(ContractType).includes(contractType as ContractType))
    return contractType as ContractType;

  return undefined;
};
